import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchClientPortalDeliveryIssues } from '../api/clientPortalApi';
import { Spinner, ListGroup, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export function ClientPortalDeliveryIssues() {
    const { data, isLoading, isError } = useQuery({
        queryKey: ['client-portal-delivery-issues'],
        queryFn: fetchClientPortalDeliveryIssues,
    });

    if (isLoading) {
        return (
            <div className="text-center py-3">
                <Spinner animation="border" size="sm" />
            </div>
        );
    }

    if (isError || !data?.results || data.results.length === 0) {
        return null;
    }

    return (
        <div className="mt-4">
            <h4>Check deliveries:</h4>
            <ListGroup>
                {data.results.map((delivery, index) => {
                    const serialsMissing = delivery.serial_numbers_state === 'in_progress';
                    const customsMissing = ['open', 'in_progress'].includes(delivery.customs_documents_state);
                    return (
                        <ListGroup.Item key={index} className="d-flex justify-content-between align-items-start flex-column">
                            <div className="d-flex flex-wrap align-items-baseline gap-2">
                                {delivery.sales_order?.name ? (
                                    <Link to={`/client/orders/${delivery.sales_order.name}`} className="fw-bold text-decoration-none">
                                        {delivery.sales_order.name}
                                    </Link>
                                ) : (
                                    <span className="text-muted">No linked sales order</span>
                                )}
                                <small className="text-muted">{delivery.name}</small>
                            </div>
                            <div className="small text-muted">{delivery.partner?.name}</div>
                            <div className="mt-1">
                                {serialsMissing && (
                                    <Badge bg="warning" text="dark" className="me-1">
                                        Serial numbers missing
                                    </Badge>
                                )}
                                {customsMissing && (
                                    <Badge bg="danger">
                                        Customs Documents missing
                                    </Badge>
                                )}
                                {!serialsMissing && !customsMissing && (
                                    <Badge bg="success">
                                        All documents present
                                    </Badge>
                                )}
                            </div>
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        </div>
    );
}
